import { NgModule } from '@angular/core';

import { DelayedHoverDirective } from '~shared/directives/delayed-hover/delayed-hover.directive';

@NgModule({
  exports: [DelayedHoverDirective],
  declarations: [DelayedHoverDirective],
})
export class DelayedHoverModule {
}
